import React, { Component } from 'react';
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl, FormattedMessage } from 'react-intl';
import cx from 'classnames';
import {
    Form,
    Col,
    Row,
    Container,
    Button
} from 'react-bootstrap';

import s from './RideFareForm.css';
import messages from '../../../../locale/messages';
import validate from './validate';
import submit from './submit';
import Link from '../../../Link';
import Loader from '../../../Common/Loader';
import { getWeekDays, generateSurgeTimes } from '../../../../helpers/rideSurgeTimes';

const startTimeOptions = generateSurgeTimes();
const endTimeOptions = generateSurgeTimes({ includeNextDayMidnight: true });

export class RideFareForm extends Component {
    static defaultProps = {
        loading: false,
        locations: [],
        categories: [],
        availableCurrencies: []
    };

    constructor(props) {
        super(props);
        this.renderSurgePricing = this.renderSurgePricing.bind(this);
        this.handlePricingTypeChange = this.handlePricingTypeChange.bind(this);
    }

    renderField = ({ input, label, type, meta: { touched, error }, fieldClass, placeholder }) => {
        const { formatMessage } = this.props.intl;
        return (
            <Form.Group className={cx(s.space5, 'positionRelative')}>
                <Form.Label className={'inputLabel'}>{label}</Form.Label>
                <Form.Control {...input} placeholder={placeholder} type={type} className={fieldClass} />
                {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
            </Form.Group>
        );
    }

    renderSelectField = ({ input, label, meta: { touched, error }, children, className }) => {
        const { formatMessage } = this.props.intl;
        return (
            <Form.Group className={cx(s.space5, 'positionRelative')}>
                <Form.Label className={'inputLabel'}>{label}</Form.Label>
                <Form.Control as="select" {...input} className={className}>
                    {children}
                </Form.Control>
                {touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
            </Form.Group>
        );
    }

    // Keeps only the value that matches the chosen pricing type, so a window
    // never carries both a date and a weekday.
    handlePricingTypeChange(index, value) {
        const { change } = this.props;
        const pricingType = Number(value);

        change(`surgePricing[${index}].pricingType`, pricingType);

        if (pricingType === 2) {
            change(`surgePricing[${index}].datePricingValue`, null);
            change(`surgePricing[${index}].dayPricingValue`, 'Sunday');
        } else {
            change(`surgePricing[${index}].dayPricingValue`, null);
        }
    }

    renderSurgePricing({ fields }) {
        const { formatMessage } = this.props.intl;
        const { surgePricing } = this.props;
        const dayOptions = getWeekDays();

        return (
            <div className={s.surgeSection}>
                <h3 className={cx(s.surgeHeading, 'textAlignRightRTL')}>
                    <FormattedMessage {...messages.surgePriceDetails} />
                </h3>
                {
                    fields.map((item, index) => {
                        const currentItem = surgePricing && surgePricing[index];
                        const pricingType = currentItem ? Number(currentItem.pricingType) : 1;

                        return (
                            <div className={s.surgeRow} key={index}>
                                <Row>
                                    <Col lg={4} md={6} sm={12} xs={12}>
                                        <Field
                                            name={`${item}.pricingType`}
                                            component={this.renderSelectField}
                                            label={formatMessage(messages.pricingType)}
                                            className={cx(s.formControlSelect, s.formControlInput)}
                                            onChange={(e) => this.handlePricingTypeChange(index, e.target.value)}
                                        >
                                            <option value={1}>{formatMessage(messages.date)}</option>
                                            <option value={2}>{formatMessage(messages.day)}</option>
                                        </Field>
                                    </Col>
                                    <Col lg={4} md={6} sm={12} xs={12}>
                                        {
                                            pricingType === 2
                                                ? <Field
                                                    name={`${item}.dayPricingValue`}
                                                    component={this.renderSelectField}
                                                    label={formatMessage(messages.day)}
                                                    className={cx(s.formControlSelect, s.formControlInput)}
                                                >
                                                    {
                                                        dayOptions.map((day, dayIndex) => (
                                                            <option value={day} key={dayIndex}>
                                                                {messages[day] ? formatMessage(messages[day]) : day}
                                                            </option>
                                                        ))
                                                    }
                                                </Field>
                                                : <Field
                                                    name={`${item}.datePricingValue`}
                                                    type="date"
                                                    component={this.renderField}
                                                    label={formatMessage(messages.date)}
                                                    fieldClass={s.formControlInput}
                                                />
                                        }
                                    </Col>
                                    <Col lg={4} md={6} sm={12} xs={12}>
                                        <Field
                                            name={`${item}.startTime`}
                                            component={this.renderSelectField}
                                            label={formatMessage(messages.startTime)}
                                            className={cx(s.formControlSelect, s.formControlInput)}
                                        >
                                            {
                                                startTimeOptions.map((time, timeIndex) => (
                                                    <option value={time.value} key={timeIndex}>{time.label}</option>
                                                ))
                                            }
                                        </Field>
                                    </Col>
                                    <Col lg={4} md={6} sm={12} xs={12}>
                                        <Field
                                            name={`${item}.endTime`}
                                            component={this.renderSelectField}
                                            label={formatMessage(messages.endTime)}
                                            className={cx(s.formControlSelect, s.formControlInput)}
                                        >
                                            {
                                                endTimeOptions.map((time, timeIndex) => (
                                                    <option value={time.value} key={timeIndex}>{time.label}</option>
                                                ))
                                            }
                                        </Field>
                                    </Col>
                                    <Col lg={4} md={6} sm={12} xs={12}>
                                        <Field
                                            name={`${item}.surgeValue`}
                                            type="text"
                                            component={this.renderField}
                                            label={formatMessage(messages.surgeValue)}
                                            placeholder={'1.5'}
                                            fieldClass={s.formControlInput}
                                        />
                                    </Col>
                                    <Col lg={4} md={6} sm={12} xs={12}>
                                        <Field
                                            name={`${item}.isEnable`}
                                            component={this.renderSelectField}
                                            label={formatMessage(messages.status)}
                                            className={cx(s.formControlSelect, s.formControlInput)}
                                        >
                                            <option value={true}>{formatMessage(messages.enable)}</option>
                                            <option value={false}>{formatMessage(messages.disable)}</option>
                                        </Field>
                                    </Col>
                                </Row>
                                <div className={cx(s.textAlignRight, 'textAlignLeftRTL')}>
                                    {
                                        fields.length > 1 && <Button
                                            type="button"
                                            onClick={() => fields.remove(index)}
                                            className={cx(s.linkBtn, 'linkBtnRTL')}
                                        >
                                            <FormattedMessage {...messages.delete} />
                                        </Button>
                                    }
                                    {
                                        fields.length - 1 === index && <Button
                                            type="button"
                                            onClick={() => fields.push({
                                                pricingType: 1,
                                                dayPricingValue: null,
                                                datePricingValue: '',
                                                startTime: 0,
                                                endTime: 0.5,
                                                surgeValue: '',
                                                isEnable: true
                                            })}
                                            className={cx(s.linkBtn, 'linkBtnRTL')}
                                        >
                                            <FormattedMessage {...messages.add} />
                                        </Button>
                                    }
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        );
    }

    handleSurgeToggle(value) {
        const { change, surgePricing } = this.props;
        const isSurgePrice = value == 'true' || value == true;

        change('isSurgePrice', isSurgePrice);

        if (isSurgePrice && (!surgePricing || surgePricing.length === 0)) {
            change('surgePricing', [{
                pricingType: 1,
                dayPricingValue: null,
                datePricingValue: '',
                startTime: 0,
                endTime: 0.5,
                surgeValue: '',
                isEnable: true
            }]);
        }
    }

    render() {
        const {
            handleSubmit, submitting, loading, id,
            locations, categories, availableCurrencies, isSurgePrice
        } = this.props;
        const { formatMessage } = this.props.intl;
        const showSurge = isSurgePrice == true || isSurgePrice == 'true';

        return (
            <div>
                <Container fluid>
                    <Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
                        <Row>
                            <Col lg={12} md={12} sm={12} xs={12} className={s.blackCenter}>
                                <div className={s.blackCenterSection}>
                                    <Row>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="locationId"
                                                component={this.renderSelectField}
                                                label={formatMessage(messages.location)}
                                                className={cx(s.formControlSelect, s.formControlInput)}
                                            >
                                                <option value="">{formatMessage(messages.location)}</option>
                                                {
                                                    locations && locations.map((location, index) => (
                                                        <option value={location.id} key={index}>{location.locationName}</option>
                                                    ))
                                                }
                                            </Field>
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="categoryId"
                                                component={this.renderSelectField}
                                                label={formatMessage(messages.category)}
                                                className={cx(s.formControlSelect, s.formControlInput)}
                                            >
                                                <option value="">{formatMessage(messages.category)}</option>
                                                {
                                                    categories && categories.map((category, index) => (
                                                        <option value={category.id} key={index}>{category.categoryName}</option>
                                                    ))
                                                }
                                            </Field>
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="currency"
                                                component={this.renderSelectField}
                                                label={formatMessage(messages.currency)}
                                                className={cx(s.formControlSelect, s.formControlInput)}
                                            >
                                                <option value="">{formatMessage(messages.currency)}</option>
                                                {
                                                    availableCurrencies && availableCurrencies.map((currency, index) => (
                                                        currency.isEnable && <option value={currency.symbol} key={index}>{currency.symbol}</option>
                                                    ))
                                                }
                                            </Field>
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="basePrice"
                                                type="text"
                                                component={this.renderField}
                                                label={formatMessage(messages.minBaseFare)}
                                                placeholder={formatMessage(messages.minBaseFare)}
                                                fieldClass={s.formControlInput}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="unitPrice"
                                                type="text"
                                                component={this.renderField}
                                                label={formatMessage(messages.unitPrice)}
                                                placeholder={formatMessage(messages.unitPrice)}
                                                fieldClass={s.formControlInput}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="minutePrice"
                                                type="text"
                                                component={this.renderField}
                                                label={formatMessage(messages.minutePrice)}
                                                placeholder={formatMessage(messages.minutePrice)}
                                                fieldClass={s.formControlInput}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="baseFare"
                                                type="text"
                                                component={this.renderField}
                                                label={formatMessage(messages.baseFare)}
                                                placeholder={formatMessage(messages.baseFare)}
                                                fieldClass={s.formControlInput}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="waitingPrice"
                                                type="text"
                                                component={this.renderField}
                                                label={formatMessage(messages.waitingFare)}
                                                placeholder={formatMessage(messages.waitingFare)}
                                                fieldClass={s.formControlInput}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="riderFeeValue"
                                                type="text"
                                                component={this.renderField}
                                                label={formatMessage(messages.riderCommission)}
                                                placeholder={formatMessage(messages.riderCommission)}
                                                fieldClass={s.formControlInput}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="driverFeeValue"
                                                type="text"
                                                component={this.renderField}
                                                label={formatMessage(messages.driverCommission)}
                                                placeholder={formatMessage(messages.driverCommission)}
                                                fieldClass={s.formControlInput}
                                            />
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="isActive"
                                                component={this.renderSelectField}
                                                label={formatMessage(messages.status)}
                                                className={cx(s.formControlSelect, s.formControlInput)}
                                            >
                                                <option value={true}>{formatMessage(messages.active)}</option>
                                                <option value={false}>{formatMessage(messages.inactive)}</option>
                                            </Field>
                                        </Col>
                                        <Col lg={4} md={6} sm={12} xs={12}>
                                            <Field
                                                name="isSurgePrice"
                                                component={this.renderSelectField}
                                                label={formatMessage(messages.isSurgePrice)}
                                                className={cx(s.formControlSelect, s.formControlInput)}
                                                onChange={(e) => this.handleSurgeToggle(e.target.value)}
                                            >
                                                <option value={false}>{formatMessage(messages.no)}</option>
                                                <option value={true}>{formatMessage(messages.yes)}</option>
                                            </Field>
                                        </Col>
                                    </Row>
                                    {
                                        showSurge && <Row>
                                            <Col lg={12} md={12} sm={12} xs={12}>
                                                <FieldArray name="surgePricing" component={this.renderSurgePricing} />
                                            </Col>
                                        </Row>
                                    }
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className={cx(s.textAlignRight, s.spaceTop1, s.btnMargin, 'textAlignLeftRTL', 'btnPaddingRTL')}>
                                <Form.Group className={s.noMargin}>
                                    <Link to={"/siteadmin/ride-fare"} className={cx(s.backBtnTwo, s.btnSecondaryBorder, s.linkBtnInline, 'backBtnTwoRTL', s.backBtnTwoTop)}>
                                        {formatMessage(messages.goBack)}
                                    </Link>
                                    <div className={s.displayInlineBlock}>
                                        <Loader
                                            type={"button"}
                                            label={id ? formatMessage(messages.update) : formatMessage(messages.submitButton)}
                                            show={loading}
                                            buttonType={'submit'}
                                            className={cx(s.button, s.btnPrimary)}
                                            disabled={submitting || loading}
                                            isSuffix={true}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
        );
    }
}

const RideFareReduxForm = reduxForm({
    form: 'RideFareForm',
    onSubmit: submit,
    validate,
    enableReinitialize: true
})(RideFareForm);

const selector = formValueSelector('RideFareForm');

const mapState = (state) => ({
    isSurgePrice: selector(state, 'isSurgePrice'),
    surgePricing: selector(state, 'surgePricing'),
    availableCurrencies: state.currency && state.currency.availableCurrencies,
    loading: state.loader.RideFareForm
});

const mapDispatch = {};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(RideFareReduxForm)));
